import React from "react";
import PropTypes from "prop-types";

import MyMaorHeader from "../../organisms/MyMaorHeader";
import Footer from "../../organisms/Footer";
import classes from "./MyMaorLayout.module.scss";

const MyMaorLayout = ({ children }) => (
  <div className={classes.container}>
    <MyMaorHeader />
    <main className={classes.main}>{children}</main>
    <Footer />
  </div>
);

MyMaorLayout.propTypes = {
  children: PropTypes.node,
};

export default MyMaorLayout;
